import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithAuthInterceptor } from "./util";

export const shiftDailyScheduleApi = createApi({
  reducerPath: "shiftDailyScheduleApi",
  baseQuery: baseQueryWithAuthInterceptor({ baseUrl: "/api/" }),
  tagTypes: ["ShiftDailySchedule"],
  endpoints: (builder) => ({
    getSchedulesByMetro: builder.query({
      query: ({ metro, hub, fromDate, toDate }) => {
        const params = {};
        if (metro) params.metro = metro;
        if (hub) params.hub = hub;
        if (fromDate) params.fromDate = fromDate;
        if (toDate) params.toDate = toDate;
        return {
          url: "shift-schedules",
          params,
        };
      },
      providesTags: ["ShiftDailySchedule"],
    }),
    upsertSchedule: builder.mutation({
      query: (body) => ({
        url: "shift-schedules",
        method: "POST",
        body,
      }),
      invalidatesTags: (result, error, arg) =>
        !error && ["ShiftDailySchedule"],
    }),
  }),
});

export const {
  useGetSchedulesByMetroQuery,
  useUpsertScheduleMutation,
} = shiftDailyScheduleApi;
